import React, { useEffect } from "react"
import { FaTwitter, FaGithub } from "react-icons/fa"
import { FaXTwitter } from "react-icons/fa6"
import { MdEmail } from "react-icons/md"
import { AiOutlineProfile } from "react-icons/ai";
import { TWITTER_LINK, EMAIL, GITHUB_LINK } from '../../constants'
import Link from "../Link"
import styled from 'styled-components'

const SubMenu = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
`

const ContentLink = styled.span`
    line-height: 1.5;
    color: ${({color}) => color};
    font-size: 12px;
`

const Socials = ({ iconColor, textColor }) => {
  const [windowDimenion, detectHW] = React.useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%", gap: "22px"}}>
      <SubMenu>
        <div class="mailto"
          onClick={(e) => {
            window.location.href = `mailto:${EMAIL}`;
            e.preventDefault();
          }}
          style={{
            cursor: "pointer"
          }}>
          <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
            <MdEmail size={14} color={iconColor} />
            <ContentLink color={textColor}>{"Email"}</ContentLink>
          </div>
        </div>
      </SubMenu>
      <SubMenu>
        <Link href={`${process.env.PUBLIC_URL + "/CV.pdf"}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
          <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
            <AiOutlineProfile size={14} color={iconColor} />
            <ContentLink color={textColor}>{"CV"}</ContentLink>
          </div>
        </Link>
      </SubMenu>
      <SubMenu>
        <Link href={`${TWITTER_LINK}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
          <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
            <FaXTwitter size={14} color={iconColor} />
            <ContentLink color={textColor}>{"Twitter"}</ContentLink>
          </div>
        </Link>
      </SubMenu>
      <SubMenu>
        <Link href={`${GITHUB_LINK}`} target="_blank" style={{ cursor: "pointer", textDecoration: "none" }}>
          <div style={{display: "flex", flexDirection: "row", gap: "6px", alignItems: "center"}}>
            <FaGithub size={14} color={iconColor} />
            <ContentLink color={textColor}>{"GitHub"}</ContentLink>
          </div>
        </Link>
      </SubMenu>
    </div>
  )
}

export default Socials;